var map = {
	"./adobe-illustrator.svg": 9125,
	"./adobe-photoshop.svg": 1046,
	"./figma.svg": 760,
	"./github.svg": 3241,
	"./heroku.svg": 3832,
	"./jira.svg": 3024,
	"./storybook.svg": 9396,
	"./vscode.svg": 3530
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2855;